import { MtProjectGroup, MtUser } from "server/models"
import { OrderType } from "client/utils"
import { ProjectGroupFilters, UserFilters } from "client/store"

export interface ProjectGroupUserProps {
    group: MtProjectGroup
}
export interface ProjectUserGroupProps {
    user: MtUser
}

export interface ProjectUserGroupList { [userId: number]: readonly number[]}
export interface ProjectGroupUserList { [groupId: number]: readonly number[]}

export interface ProjectUserGroupState {
    userGroupList: ProjectUserGroupList
    groupUserList: ProjectGroupUserList

    assignedGroups: {
        groupIds: readonly number[]
        sortColumn: keyof MtProjectGroup
        sortOrder: OrderType
        filters: ProjectGroupFilters
    }
    notAssignedGroups: {
        groupIds: readonly number[]
        sortColumn: keyof MtProjectGroup
        sortOrder: OrderType
        filters: ProjectGroupFilters
        selected: readonly number[]
    }

    assignedUsers: {
        userIds: readonly number[]
        sortColumn: keyof MtUser
        sortOrder: OrderType
        filters: UserFilters
    }
    notAssignedUsers: {
        userIds: readonly number[]
        sortColumn: keyof MtUser
        sortOrder: OrderType
        filters: UserFilters
        selected: readonly number[]
    }

    reloadUserGroupList: boolean
    reloadGroupUserList: boolean
}

export const PROJECT_USER_GROUP_LIST = "PROJECT_USER_GROUP_LIST"
export const PROJECT_GROUP_USER_LIST = "PROJECT_GROUP_USER_LIST"

export const ASSIGNED_PROJECT_USER_GROUP_IDS = "ASSIGNED_PROJECT_USER_GROUP_IDS"
export const ASSIGNED_PROJECT_USER_GROUP_SORT = "ASSIGNED_PROJECT_USER_GROUP_SORT"
export const ASSIGNED_PROJECT_USER_GROUP_FILTERS = "ASSIGNED_PROJECT_USER_GROUP_FILTERS"

export const NOT_ASSIGNED_PROJECT_USER_GROUP_IDS = "NOT_ASSIGNED_PROJECT_USER_GROUP_IDS"
export const NOT_ASSIGNED_PROJECT_USER_GROUP_SORT = "NOT_ASSIGNED_PROJECT_USER_GROUP_SORT"
export const NOT_ASSIGNED_PROJECT_USER_GROUP_FILTERS = "NOT_ASSIGNED_PROJECT_USER_GROUP_FILTERS"
export const NOT_ASSIGNED_PROJECT_USER_GROUP_SELECTED = "NOT_ASSIGNED_PROJECT_USER_GROUP_SELECTED"

export const ASSIGNED_PROJECT_GROUP_USER_IDS = "ASSIGNED_PROJECT_GROUP_USER_IDS"
export const ASSIGNED_PROJECT_GROUP_USER_SORT = "ASSIGNED_PROJECT_GROUP_USER_SORT"
export const ASSIGNED_PROJECT_GROUP_USER_FILTERS = "ASSIGNED_PROJECT_GROUP_USER_FILTERS"

export const NOT_ASSIGNED_PROJECT_GROUP_USER_IDS = "NOT_ASSIGNED_PROJECT_GROUP_USER_IDS"
export const NOT_ASSIGNED_PROJECT_GROUP_USER_SORT = "NOT_ASSIGNED_PROJECT_GROUP_USER_SORT"
export const NOT_ASSIGNED_PROJECT_GROUP_USER_FILTERS = "NOT_ASSIGNED_PROJECT_GROUP_USER_FILTERS"
export const NOT_ASSIGNED_PROJECT_GROUP_USER_SELECTED = "NOT_ASSIGNED_PROJECT_GROUP_USER_SELECTED"

export const PROJECT_USER_GROUP_RELOAD_LIST = "PROJECT_USER_GROUP_RELOAD_LIST"
export const PROJECT_GROUP_USER_RELOAD_LIST = "PROJECT_GROUP_USER_RELOAD_LIST"
